export default __webpack_public_path__ + "static/media/new-recipe.d520f5bb.svg";